// extracted by mini-css-extract-plugin
export default {"link":"dark_link__6EZQg","linkImg":"dark_linkImg__Bk17P color_colorLightBackground__vzlHN","linkOverflov":"dark_linkOverflov__MVYYD undefined"};